import { Flex, Text, chakra, Spacer, Tooltip } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
// import { wenxinStore } from "@/thirdParty/wenxin/store";
import { ReactComponent as InfoSvg } from "@/assets/icons/info.svg";
import Icon from "@/components/Icon";
import { observer } from "mobx-react-lite";
import { userAssetsStore } from "@/stores/userAssets";

const themeColor = "#36C19E";
const WenxinStatus: React.FC = () => {
  // const [open, setOpen] = useState(false);
  const {
    heartCoinInfo: { free, total, payed },
    setHeartCoinPayModalOpen,
  } = userAssetsStore;

  return (
    <>
      <Flex w="100%" fontSize="12px" lineHeight="22px" align="center" color="#DCDCDC">
        <Flex align="center">
          <chakra.span whiteSpace="nowrap">剩余画力星：</chakra.span>
          <chakra.span>{total}</chakra.span>
          <Tooltip
            placement="right-start"
            hasArrow
            bg="#5F5F5F"
            arrowSize={5}
            offset={[-8, 8]}
            label={
              <Flex flexDir="column" fontSize="14px" lineHeight="22px" p="8px 12px" color="white">
                <Text>今日有效：{free}</Text>
                <Text>永久有效：{payed}</Text>
              </Flex>
            }
          >
            <chakra.div ml="4px" cursor="pointer" onClick={() => setHeartCoinPayModalOpen(true)}>
              <Icon style={{ fontSize: "12px" }} svg={InfoSvg} />
            </chakra.div>
          </Tooltip>
        </Flex>
        <Spacer />
        <Text color={themeColor} cursor="pointer" onClick={() => setHeartCoinPayModalOpen(true)}>
          获得更多
        </Text>
      </Flex>
    </>
  );
};

export default observer(WenxinStatus);
